import { GET_SUPPORT_TICKET_ACTIONS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    actions: Action[];
    description: string;
    error?: string;
}

export interface Action {
    created_at: string;
    text: string;
}

export default (id: string): Promise<Response> => {
    return fetchWithRefresh(GET_SUPPORT_TICKET_ACTIONS(id)).then((res) => res.json());
};
